/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureInfoMaterialsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    tagUrl: lc.get(data, 'tag_url'),
    title: lc.get(data, 'title'),
    desc: lc.get(data, 'desc'),
    content: lc.get(data, 'content')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/services/InfoMaterialsService/restructuring/index.js